import React from "react";

import GoalForm from "./GoalForm";

const AddGoal = () => {
    return <GoalForm mode="add" />;
};

export default AddGoal;
